import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import { useQuizContext } from '../context/QuizContext';
import TimerIcon from '@mui/icons-material/Timer';
export const formatTime = (time) => {
    let min = Math.floor(time / 60);
    let seconds = Math.floor(time - min * 60);
    if (min < 10) min = '0' + min;
    if (seconds < 10) seconds = '0' + seconds
    return min + ':' + seconds
}

const CountDown = ({ start }) => {
   
    const { countdown, setCountDown, showResult, setShowResult, seconds, takeTime, setTakeTime } = useQuizContext();
    const timerId = useRef();

    useEffect(() => {
        timerId.current = setInterval(() => {
            setCountDown((prev) => prev - 1);
            setTakeTime((prev) => prev + 1);

        }, 1000)
        return () => clearInterval(timerId.current)
    }, [])

    useEffect(() => {

        if (countdown <= 0) {
            clearInterval(timerId.current);
            toast.error("Time End!")
            setShowResult(true);
        }
    }, [countdown])
    return (
        <>
            <div className='d-flex' style={{color:"red"}}><TimerIcon sx={{color:"red"}}/> <h4>{formatTime(countdown)}</h4> </div>

        </>

    )
}

export default CountDown